/* eslint-disable @typescript-eslint/no-explicit-any */
// Utility to parse and stringify nested query parameters like `filter[name]=value` (same as qs library)

export const nestedQueryParams = {
    /**
     * Stringify objet style { user: { id: "123", role: "admin" } }
     * as query params "user[id]=123&user[role]=admin"
     */
    stringify(obj: Record<string, any>): string {
        const params = new URLSearchParams()

        const buildParams = (prefix: string, value: any) => {
            if (value === undefined || value === null) return

            if (typeof value === "object" && !Array.isArray(value)) {
                for (const [key, val] of Object.entries(value)) {
                    buildParams(prefix ? `${prefix}[${key}]` : key, val)
                }
            } else {
                params.append(prefix, String(value))
            }
        }

        buildParams("", obj)

        return params.toString()
    },

    /**
     * Parse query params style "user[id]=123&user[role]=admin"
     * as object { user: { id: "123", role: "admin" } }
     */
    parse(query: Record<string, string | string[] | undefined>): Record<string, any> {
        const result: Record<string, any> = {}

        for (const [key, value] of Object.entries(query)) {
            if (value === undefined) continue

            const parts = key.split(/[\[\]]+/).filter(Boolean)
            let current = result

            for (let i = 0; i < parts.length - 1; i++) {
                const part = parts[i]
                current[part] ??= {}
                current = current[part]
            }

            const lastPart = parts[parts.length - 1]

            if (lastPart) {
                current[lastPart] = Array.isArray(value) ? value[0] : value
            }
        }

        return result
    },
}
